module.exports = __webpack_public_path__ + "static/media/main idea.b43104ce.mp3";